import React from 'react';
import { useSelector } from 'react-redux';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { useSocioeconomicChartsData } from '../../../../hooks/useSocioeconomicChartsData';
import { colorsPieCharts } from '../../../../shared/constants';
import { GenericChartCard } from '../../../../component/charts/genericChartCard';
import { ErrorState } from './errorState';
import {
  generateTitleAndSource,
  renderLegend,
} from './socioeconomicDemographicCharts';
import nls from '../nls/pt-BR.json';

export const ResidenceCondition = () => {
  const { errorFetchData } =
    useSelector((state: any) => state.socioeconomicDemographicState) || '';
  const { residenceConditionFormattedData } = useSocioeconomicChartsData();
  return (
    <GenericChartCard
      title={generateTitleAndSource(
        nls.charts.residenceCondition.residenceCondition,
        nls.disclaimers.dataSourceIBGE2010
      )}
    >
      {errorFetchData?.residenceCondition ? (
        <ErrorState />
      ) : (
        <ResponsiveContainer width="100%" height="75%">
          <PieChart width={400} height={400}>
            <Pie
              data={residenceConditionFormattedData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              labelLine={false}
              fill="#8884d8"
            >
              {residenceConditionFormattedData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colorsPieCharts[index % colorsPieCharts.length]}
                />
              ))}
            </Pie>
            <Legend
              verticalAlign="bottom"
              height={60}
              content={renderLegend(residenceConditionFormattedData)}
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </GenericChartCard>
  );
};
